import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { HttpClient, HttpParams } from "@angular/common/http";
import { MatTableDataSource } from "@angular/material/table";
import { urlConstant } from "../../../constant/urlConstant";
import { ChangeDetectorRef } from "@angular/core";

import { CommonService } from "../../../common/commonService";
interface AuditEvent {
  eventName: string;
  eventTimeStamp: string;
  partnerId?: string | null;
  roleId?: number | null;
  deviceType?: string | null;
  roleName?: string;
}

@Component({
  selector: "app-audit-events",
  templateUrl: "./audit-events.component.html",
  styleUrls: ["./audit-events.component.scss"],
})
export class AuditEventsComponent implements OnInit {
  loginUserDetail: any = null;

  constructor(
    private http: HttpClient,
    private fb: FormBuilder,
    private _CommonService: CommonService,
    private cdr: ChangeDetectorRef
  ) {}
  getLoggedInUserDetails(): void {
    this.loginUserDetail = this._CommonService.getLoggedInUser();


    if (this.loginUserDetail) {
      if (this.loginUserDetail.roleId === 100) {
        this.applyFiltersBySuperAdmin();
        this.cdr.detectChanges();

        this.filterForm.controls["partnerId"].enable();
      } else {

        this.filterForm.patchValue({
          partnerId: this.loginUserDetail.partnerId,
        });
        this.filterForm.controls["partnerId"].disable();

        this.applyFiltersByPartnerAdmin();
        this.cdr.detectChanges();
      }
      this.cdr.detectChanges();
    } else {
      console.error("Failed to retrieve user details.");
    }
  }

  displayedColumns: string[] = [
    "eventName",
    "eventTimeStamp",
    "partnerId",
    "roleName",
    "deviceType",
  ];
  dataSource = new MatTableDataSource<AuditEvent>([]);
  filterForm!: FormGroup;
  totalEvents: number = 0;
  searchKey: string = "";

  roles = [
    { id: 100, name: "Super Admin" },
    { id: 111, name: "Owner" },
    { id: 222, name: "Property Manager" },
    { id: 333, name: "Tenant" },
    { id: 444, name: "Partner Admin" },
    { id: 555, name: "Vendor" },
    { id: 666, name: "Maintenance Manager" },
  ];

  deviceTypes = ["mobile", "desktop"];

  partnerIds = [
    "stag.easerent.com",
    "growmaxwealth.easerent.com",
    "stagapp.easerent.com",
    "johnrealestate.easerent.com",
    "puran.com",
    "renttou.easerent.com",
    "rentkochi.easerent.com",
    "nestguru.easerent.com",
    "growmaxwealth.easerent.com",
    "avrr.easerent.com",
    "arr.easerent.com",
    "yellowwstone.easerent.com",
    "banerproperties.easerent.com",
    "shivassociates.easerent.com",
    "skyproperties.easerent.com",
    "omkarrealestates.easerent.com",
    "valuehome.easerent.com",
    "proptmart.easerent.com",
    "squarefeetrealtor.easerent.com",
    "bhagvanrealestates.easerent.com",
    "suyogproperty.easerent.com",
    "puneproperties.easerent.com",
    "jaipurflat.easerent.com",
    "househikes.easerent.com",
    "keshavworld.easerent.com",
    "rajithaestate.easerent.com",
    "shiventerprise.easerent.com",
    "omkarenterprise.easerent.com",
    "aashianaproperties.easerent.com",
    "msrdevelopers.easerent.com",
    "lodestar.easerent.com",
    "raprotesting.easerent.com",
    "easerent.devnion.com",
  ];

  ngOnInit(): void {
    this.filterForm = this.fb.group({
      eventName: new FormControl(""),
      partnerId: new FormControl({ value: "", disabled: true }),
      deviceType: new FormControl(""),
      eventTimeStamp: new FormControl(""),
      roleId: new FormControl(null),
    });

    this.getLoggedInUserDetails();
    this.cdr.detectChanges();
  }
  handleFormSubmit() {
    if (this.loginUserDetail.roleId === 100) {
      this.applyFiltersBySuperAdmin();
    } else {
      this.applyFiltersByPartnerAdmin();
    }
    this.cdr.detectChanges();
  }

  applyFiltersBySuperAdmin(): void {
    let params = new HttpParams();

    Object.keys(this.filterForm.value).forEach((key) => {
      let value = this.filterForm.value[key];

      if (key === "eventTimeStamp" && value) {
        const date = new Date(value);
        const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${date
          .getDate()
          .toString()
          .padStart(2, "0")} ${date
          .getHours()
          .toString()
          .padStart(2, "0")}:${date
          .getMinutes()
          .toString()
          .padStart(2, "0")}:${date
          .getSeconds()
          .toString()
          .padStart(2, "0")}.${date
          .getMilliseconds()
          .toString()
          .padEnd(6, "0")}`;

        value = formattedDate;
      }

      if (value !== null && value !== "") {
        params = params.set(key, value.toString());
      }
    });

    this.http
      .get<AuditEvent[]>(urlConstant.Admin.getAuditEventDetailsByFilter, {
        params,
      })
      .subscribe(
        (data) => {
          if (!data || data.length === 0) {
            this.dataSource.data = [
              {
                eventName: "No Data Available",
                eventTimeStamp: "N/A",
                partnerId: "N/A",
                roleId: null,
                deviceType: "N/A",
                roleName: "N/A",
              },
            ];
          } else {
            this.dataSource.data = this.mapRoleNames(data);
          }

          this.totalEvents = this.dataSource.data.length;
          this.dataSource._updateChangeSubscription();
        },
        (error) => {
          console.error("Error fetching filtered audit events:", error);
          this.dataSource.data = [
            {
              eventName: "No Data Available",
              eventTimeStamp: "N/A",
              partnerId: "N/A",
              roleId: null,
              deviceType: "N/A",
              roleName: "N/A",
            },
          ];
          this.totalEvents = 1;
        }
      );
      this.cdr.detectChanges();
  }

  applyFiltersByPartnerAdmin(): void {
    let params = new HttpParams();

    if (this.loginUserDetail.roleId !== 100) {
      params = params.set("partnerId", this.loginUserDetail.partnerId);
    }

    Object.keys(this.filterForm.value).forEach((key) => {
      let value = this.filterForm.value[key];

      if (key === "eventTimeStamp" && value) {
        const date = new Date(value);
        const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${date
          .getDate()
          .toString()
          .padStart(2, "0")} ${date
          .getHours()
          .toString()
          .padStart(2, "0")}:${date
          .getMinutes()
          .toString()
          .padStart(2, "0")}:${date
          .getSeconds()
          .toString()
          .padStart(2, "0")}.${date
          .getMilliseconds()
          .toString()
          .padEnd(6, "0")}`;

        value = formattedDate;
      }

      if (value !== null && value !== "" && key !== "partnerId") {
        params = params.set(key, value.toString());
      }
    });

    this.http
      .get<AuditEvent[]>(urlConstant.Admin.getAuditEventDetailsByFilter, {
        params,
      })
      .subscribe(
        (data) => {
          if (!data || data.length === 0) {
            this.dataSource.data = [
              {
                eventName: "No Data Available",
                eventTimeStamp: "N/A",
                partnerId: "N/A",
                roleId: null,
                deviceType: "N/A",
                roleName: "N/A",
              },
            ];
          } else {
            this.dataSource.data = this.mapRoleNames(data);
          }

          this.totalEvents = this.dataSource.data.length;
          this.dataSource._updateChangeSubscription();
        },
        (error) => {
          console.error("Error fetching filtered audit events:", error);
          this.dataSource.data = [
            {
              eventName: "No Data Available",
              eventTimeStamp: "N/A",
              partnerId: "N/A",
              roleId: null,
              deviceType: "N/A",
              roleName: "N/A",
            },
          ];
          this.totalEvents = 1;
        }
      );
      this.cdr.detectChanges();
  }

  clearFilters(): void {
    this.filterForm.reset();
    if (this.loginUserDetail.roleId != 100) {
      this.filterForm.patchValue({
        partnerId: this.loginUserDetail.partnerId,
      });
    }
    if (this.loginUserDetail.roleId === 100) {
      this.applyFiltersBySuperAdmin();
    } else {
      this.applyFiltersByPartnerAdmin();
    }
    this.cdr.detectChanges();
  }

  applySearch(): void {
    this.dataSource.filter = this.searchKey.trim().toLowerCase();
  }

  private mapRoleNames(events: AuditEvent[]): AuditEvent[] {
    return events.map((event) => {
      const matchedRole = this.roles.find((role) => role.id === event.roleId);

      return {
        ...event,
        roleName: matchedRole ? matchedRole.name : "Unknown Role",
        eventTimeStamp: this.formatDate(event.eventTimeStamp),
      };
    });
  }

  private formatDate(timestamp: string): string {
    if (!timestamp) return "N/A";

    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });
  }
}
